export default {"src":"/_next/static/image/public/images/ic_pay_master_card.8178137d7bf2fb47a7dd3f4700d26b13.svg","height":15,"width":26};